import React from "react";

function SectionHeading({ title }) {
  return (
    <>
      <h3 className="section-title">{title}</h3>
      <div className="section-heading-spacer" aria-hidden="true" />
    </>
  );
}

export default SectionHeading;
